import { BaseRouteService } from 'core/services';

class SubCategoryRouteService extends BaseRouteService {
    constructor() {
        super('sub-categories');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,isActive,page,rpp,sort,embed,fields,itemCategoryId}', filter);
    }
}

export default SubCategoryRouteService;
